import { useParams } from 'react-router-dom';
import * as urlUtil from '@theme/js/utils/url.util';

export const useGetPageRoutingURL = (href) => {
    const { pathLang } = useParams();

    if (!href) {
        return '';
    }

    /* Lugano changes */
    const [, protocol] = urlUtil.getPartsUrl(href);
    const hasProtocol = typeof protocol === 'string' && protocol.length > 0;

    if (urlUtil.isExternalUrl(href) || urlUtil.isHashLink(href) || hasProtocol) {
        return href;
    }
    /* Lugano changes */

    const pathWithParams = urlUtil.getPathWithParams(href);
    const { cleanUrl, lang } = urlUtil.parseUrl(pathWithParams);

    const selectedPathLang = pathLang ? `/${pathLang}` : '';

    /* Lugano changes */
    const hrefWithSlash = href.charAt(0) === '/' ? href : `/${href}`;

    return lang ? hrefWithSlash : `${selectedPathLang}${cleanUrl}`;
    /* Lugano changes */
};
